import { render } from "./ModifyIndex.vue?vue&type=template&id=e061d2d2&scoped=true"
import script from "./ModifyIndex.vue?vue&type=script&lang=js"
export * from "./ModifyIndex.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-e061d2d2"

export default script